import { css } from '@backyard-ui/styles';

export const baseStyles = css({
  display: 'block',
  variants: {
    size: {
      xs: {
        width: '$3',
        height: '$3',
      },
      sm: {
        width: '$4',
        height: '$4',
      },
      md: {
        width: '$5',
        height: '$5',
      },
      lg: {
        width: '$6',
        height: '$6',
      },
      xl: {
        width: '$7',
        height: '$7',
      },
    },
    color: {
      black: {
        fill: '$black',
      },
      critical: {
        fill: '$c500',
      },
      info: {
        fill: '$i500',
      },
      primary: {
        fill: '$p500',
      },
      secondary: {
        fill: '$s500',
      },
      warning: {
        fill: '$w500',
      },
      white: {
        fill: '$white',
      },
    },
  },
  defaultVariants: {
    size: 'md',
  },
});
